module.exports = __webpack_public_path__ + "static/media/delete_icon.985a05e0.svg";